(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-home-oct5"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
const swatch=event.target.closest('[data-ds-swatch]');
if(!swatch)return;
const card=swatch.closest('.ds-product');
const image=card.querySelector('.ds-product-image img');
if(!swatch.dataset.image||!image)return;
event.preventDefault();
image.removeAttribute('srcset');
image.src=swatch.dataset.image;
card.querySelectorAll('.ds-home-swatch').forEach(function(el){el.classList.toggle('is-selected',el===swatch)});
card.querySelectorAll('.ds-product-image,.ds-product-name,.ds-home-more').forEach(function(el){el.href=swatch.href});
const price=card.querySelector('.ds-product-price');
price.replaceChildren(document.createTextNode(swatch.dataset.price));
if(swatch.dataset.compare){const compare=document.createElement('s');compare.textContent=swatch.dataset.compare;price.append(' ',compare)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
